// export const HOME = "/";
// export const BLINDS_ROLLER = "/product-blinds-roller";
// export const BLINDS_VENETIAN = "/product-blinds-venetian";
// export const BLINDS_VERTICAL = "/product-blinds-vertical";
// export const BLINDS_ZEBRA = "/product-blinds-zebra";
// export const CURTAIN_WAVE = "/product-curtain-wave";
// export const CURTAIN_EYELET = "/product-curtain-eyelet";
// export const CURTAIN_PINCHPLEAT = "/product-curtain-pinch-pleat";
// export const SHUTTER_TIMBER = "/product-shutter-timber";
// export const SHUTTER_ALYCOREPLUSPVC = "/product-shutter-alycore-plus-pvc";
// export const SHUTTER_EXTERIOR = "/product-shutter-exterior";
// export const BUYINGGUIDE = "/buying-guide";
// export const CONTACTUS = "/contact-us";

export const HOME = "/";
export const BLINDS_ROLLER = "/product/blinds/roller";
export const MOTORISED_ROLLER = "/product/blinds/motorised_roller";
export const BLINDS_VENETIAN = "/product/blinds/venetian";
export const BLINDS_VERTICAL = "/product/blinds/vertical";
export const BLINDS_ZEBRA = "/product/blinds/zebra";
export const CURTAIN_DAY = "/product/curtains/day";
export const CURTAIN_NIGHT = "/product/curtains/night";
export const SHUTTER_TIMBER = "/product/shutters/timber";
export const SHUTTER_PVC = "/product/shutters/pvc";
export const SHUTTER_EXTERIOR = "/product/shutters/exterior";
export const SUSTAINABILITY = "/sustainability";
export const CONTACTUS = "/contact-us";
export const SHOWROOM = "/showroom";
export const PROJECTS = "/projects";

export const BUYINGGUIDE = "/buying-guide";
export const BUYINGGUIDE_BLINDS = "/buying-guide/blinds";
export const BUYINGGUIDE_CURTAINS = "/buying-guide/curtains";
export const BUYINGGUIDE_SHUTTERS = "/buying-guide/shutters";

export const HOUZZ_PROJECTS =
  "https://www.houzz.co.nz/professionals/shutters-blinds-and-curtains/soho-blinds-pfvwnz-pf~943228419#Projects";
export const HOUZZ_REVIEWS =
  "https://www.houzz.co.nz/professionals/shutters-blinds-and-curtains/soho-blinds-pfvwnz-pf~943228419#Reviews";

// https://www.houzz.co.nz/professionals/shutters-blinds-and-curtains/soho-blinds-pfvwnz-pf~943228419#Reviews
// export const path = {
//   HOME: "/",
//   BLINDS_ROLLER: "/product/blinds/roller",
//   BLINDS_VENETIAN: "/product/blinds/venetian",
//   BLINDS_VERTICAL: "/product/blinds/vertical",
//   BLINDS_ZEBRA: "/product/blinds/zebra",
//   CURTAIN_WAVE: "/product/curtain/wave",
//   CURTAIN_EYELET: "/product/curtain/eyelet",
//   CURTAIN_PINCHPLEAT: "/product/curtain/pinch-pleat",
//   SHUTTER_TIMBER: "/product/shutter/timber",
//   SHUTTER_ALYCOREPLUSPVC: "/product/shutter/alycore-plus-pvc",
//   SHUTTER_EXTERIOR: "/product/shutter/exterior",
//   BUYINGGUIDE: "/buying-guide",
//   CONTACTUS: "/contact-us"
// };
